'use strict';

const _ = require('lodash');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');

module.exports = (input, config) => {
    _.defaults(config, {
        max: undefined,
    });

    const inputAsArray = Object.entries(input).map(([id, value]) => ({id, value}));

    let rule;

    rule = (input) => input.value === '';
    if (_.some(inputAsArray, rule)) {
        throw new ParserError(PARSER_ERRORS.OVERALL_REQUIRED, [{errorRows: inputAsArray.filter(rule).map((v) => v.id)}]);
    }

    rule = (input) => parseFloat(input.value) < 0;
    if (_.some(inputAsArray, rule)) {
        throw new ParserError(PARSER_ERRORS.OVERALL_MIN_NUMBER, [{min: 0, errorRows: inputAsArray.filter(rule).map((v) => v.id)}]);
    }

    if (_.sum(Object.values(input).map((v) => parseFloat(v))) !== config.max) {
        throw new ParserError(PARSER_ERRORS.OVERALL_COMPOSITION, [{max: config.max, errorRows: config.rows.map((r) => r.id)}]);
    }

    return input;
};
